import { ItemPickerItemOptionQuantityInputType } from '../types/config/item-option-quantity-input-type';
export const getQuantityInputType = (quantityLimit) => {
    if (quantityLimit.isUnlimited)
        return ItemPickerItemOptionQuantityInputType.Number;
    return quantityLimit.maximum === 1
        ? ItemPickerItemOptionQuantityInputType.Radio
        : ItemPickerItemOptionQuantityInputType.Number;
};
